<template>
    <div class="gmf-comment-actions-modal" v-if="comment">

        <!-- @TODO can't follow replies -->
        <button @click="toggleFollow($event, 'comment')">
            <Icon :icon="followStatus.comment ? 'comment-actions-unfollow-generic' : 'comment-actions-follow-generic'" />
            <div>
                <div>{{ followCommentLabel }}</div>
                <div class="gmf-text-small">{{ followCommentDescription }}</div>
            </div>
        </button>

        <button @click="openShareModal">
            <Icon icon="comment-actions-share" />
            <div>
                <div>{{ t('social_feed.share_post') }}</div>
                <div class="gmf-text-small">{{ t('comment_actions.share.description') }}</div>
            </div>
        </button>

        <button @click="openReportModal" v-if="reportingEnabled">
            <Icon icon="report" />
            <div>
                <div>{{ t('report.button') }}</div>
                <div class="gmf-text-small">{{ t('comment_actions.report.description') }}</div>
            </div>
        </button>

        <button v-if="!comment.author.isGuest && followCustomersEnabled" @click="toggleFollow($event, 'customer')">
            <Icon :icon="followStatus.customer ? 'comment-actions-unfollow-user' : 'comment-actions-follow-user'" />
            <div>
                <div>{{ followCustomerLabel }}</div>
                <div class="gmf-text-small">{{ followCustomerDescription }}</div>
            </div>
        </button>

        <button v-if="comment.target?.type === 'board' && followBoardsEnabled" @click="toggleFollow($event, 'social_board')">
            <Icon :icon="followStatus.social_board ? 'comment-actions-unfollow-generic' : 'comment-actions-follow-generic'" />
            <div>
                <div>{{ followBoardLabel }}</div>
                <div class="gmf-text-small">{{ followBoardDescription }}</div>
            </div>
        </button>

    </div>
</template>

<style>
.gmf-comment-actions-modal {
    display: flex;
    flex-direction: column;
    /*border-radius: var(--gmf-rounding);*/
    /*margin-top: var(--gmf-p-5);*/
    gap: var(--gmf-p-3);
}

.gmf-comment-actions-modal button {
    max-width: 100%;
    padding: var(--gmf-p-3);
    font-weight: bold;
    background: none !important;
    border: none !important;
    width: 400px;
    display: flex;
    align-items: center;
    gap: var(--gmf-p-4);
    --gmf-icon-color: var(--gmf-col-nearblack);
    color: var(--gmf-col-nearblack);
    cursor: pointer;
    border-radius: var(--gmf-rounding);
}

.gmf-comment-actions-modal button:hover {
    background: var(--gmf-col-lightgray) !important;
}

.gmf-comment-actions-modal button .gmf-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}
</style>

<script>
import callApi from '@/utils/callApi';
import state from '@/state';
import tooltip from '@/utils/tooltip';
import Icon from '@/components/Icon';
import advancedString from '@/utils/advancedString';

import openShareModal from '@/components/ShareModal/openShareModal';
import openReportModal from '@/components/ReportModal/openReportModal';

const t = state.t;

export default {
    components: {
        Icon,
    },

    inject: ['closeModal'],

    data() {
        return {
            comment: null,
            followStatus: {
                comment: false,
                customer: false,
                social_board: false,
            },
        }
    },

    computed: {
        reportingEnabled() {
            return state.merchantConfig?.widgets?.comments?.reporting?.enabled;
        },
        followCommentLabel() {
            const phrase = this.followStatus.comment ? t('unfollow_x') : t('follow_x');
            return advancedString(phrase, {x: this.commentTypeName});
        },
        followCommentDescription() {
            return this.followStatus.comment ? t('comment.actions.unfollow.comment.description') : t('comment_actions.follow.comment.description');
        },
        followCustomerLabel() {
            const phrase = this.followStatus.customer ? t('unfollow_x') : t('follow_x');
            return advancedString(phrase, {x: this.comment.author.firstName});
        },
        followCustomerDescription() {
            return this.followStatus.customer ? t('comment.actions.unfollow.customer.description') : t('comment_actions.follow.customer.description');
        },
        followBoardLabel() {
            const phrase = this.followStatus.social_board ? t('unfollow_x') : t('follow_x');
            return advancedString(phrase, {x: this.comment.target.name});
        },
        followBoardDescription() {
            return this.followStatus.social_board ? t('comment.actions.unfollow.board.description') : t('comment_actions.follow.board.description');
        },
        commentTypeName () {
            return t('comments.comment_type_name.' + this.comment.type.name) || t('comments.comment_type_name.social_post');
        },
        followableMap() {
            const map = {
                comment: null,
                customer: null,
                social_board: null,
            };
            /*if (!state.profile) {
                return map;
            }*/
            if (this.comment.merchant.id !== state.merchantId) {
                // Can't follow anything if comment is from another merchant
                return map;
            }
            map.comment = this.comment.id;
            const usr = this.comment.author;
            if (usr && usr.id !== state.profile?.id && !usr.isGuest) {
                // can't follow self, can't follow guests
                map.customer = usr.id;
            }
            if (this.comment.target?.type === 'board') {
                map.social_board = this.comment.target.id;
            }
            return map;
        },
        followBoardsEnabled() {
            return state.merchantConfig.follow?.boards?.enabled;
        },
        followCustomersEnabled() {
            return state.merchantConfig.follow?.customers?.enabled;
        },
    },

    methods: {
        t,

        openShareModal () {
            openShareModal(this.comment);
        },

        openReportModal () {
            openReportModal(this.comment);
        },

        setComment(c) {
            this.comment = c;
            this.getFollowStatus();
        },

        async getFollowStatus() {
            if (!state.profile) {
                return;
            }
            const map = this.followableMap;
            if (map.comment) {
                callApi('GET', `/v3/follow/comment/${map.comment}`).then(res => res.json()).then(res => {
                    this.followStatus.comment = res.following;
                });
            }
            if (map.customer && this.followCustomersEnabled) {
                callApi('GET', `/v3/follow/customer/${map.customer}`).then(res => res.json()).then(res => {
                    this.followStatus.customer = res.following;
                });
            }
            if (map.social_board && this.followBoardsEnabled) {
                callApi('GET', `/v3/follow/social_board/${map.social_board}`).then(res => res.json()).then(res => {
                    this.followStatus.social_board = res.following;
                });
            }
        },

        toggleFollow(ev, type) {
            if (!state.profile) {
                tooltip.create({x: ev.pageX, y: ev.pageY}, t('error_text.log_in_to_follow'));
                return;
            }
            
            if (this.followStatus[type]) {
                this.unfollow(type);
            } else {
                this.follow(type);
            }
        },

        async follow(type) {
            const id = this.followableMap[type];
            if (!id) {
                return;
            }
            const res = await callApi('POST', `/v3/follow/${type}/${id}`);
            if (res.status === 200) {
                this.followStatus[type] = true;
            } else {
                console.error('Failed to follow ' + type + ' ' + id);
            }
        },

        async unfollow(type) {
            const id = this.followableMap[type];
            if (!id) {
                return;
            }
            const res = await callApi('DELETE', `/v3/follow/${type}/${id}`);
            if (res.status === 200) {
                this.followStatus[type] = false;
            } else {
                console.error('Failed to unfollow ' + type + ' ' + id);
            }
        },
    }
}
</script>
